import { LayoutGrid, LayoutList, List } from 'lucide-react'
import { cn } from '@/lib/utils'

export type ListViewMode = 'card' | 'grid' | 'list'

const MODES: { id: ListViewMode; title: string; Icon: typeof List }[] = [
  { id: 'card', title: 'Card view', Icon: LayoutList },
  { id: 'grid', title: 'Grid view', Icon: LayoutGrid },
  { id: 'list', title: 'List view', Icon: List },
]

/** Card / grid / list group that sits on the same line as a preview header. */
export function ListViewModeToggle({
  value,
  onChange,
  testId,
  className,
}: {
  value: ListViewMode
  onChange: (mode: ListViewMode) => void
  testId?: string
  className?: string
}) {
  return (
    <div
      className={cn(
        'ml-auto flex shrink-0 items-center rounded-md border border-border p-0.5',
        className,
      )}
      role="group"
      aria-label="View mode"
      data-testid={testId}
    >
      {MODES.map(({ id, title, Icon }) => (
        <button
          key={id}
          type="button"
          onClick={() => onChange(id)}
          className={cn(
            'rounded p-1.5 transition-colors',
            value === id
              ? 'bg-primary text-primary-foreground'
              : 'text-muted-foreground hover:bg-muted',
          )}
          title={title}
          aria-pressed={value === id}
          data-testid={testId ? `${testId}-${id}` : undefined}
        >
          <Icon className="h-4 w-4" />
        </button>
      ))}
    </div>
  )
}
